<div class="modal-header">
  <h3 class="modal-title text-center">Votre abonnement est expiré</h3>
</div>
<div class="modal-body">
  <div class="text-center">
    <img alt="..." class="img-fluid"
         src="/frontend/projects/app/src/assets/images/credit-card-failed.svg">
  </div>
  <div>Votre abonnement est maintenant suspendu. Pour continuer à utiliser Optitax, veuillez vous réabonner en
    cliquant sur le bouton ci-dessous.
  </div>
</div>
<div class="modal-footer">
  <a class="btn btn-primary" data-bs-dismiss="modal" routerLink="/organization/billing/subscription/upgrade">Recommencer
    l'abonnement</a>
  <button (click)="activeModal.close(true)" class="btn btn-white" type="button">Annuler</button>
</div>
